// 设备（机器）标识：用于后台「注册与设备」限制
//
// 取 Windows 系统 MachineGuid（HKLM\SOFTWARE\Microsoft\Cryptography），
// 重装系统才会变，重装客户端/清缓存都不变。
// 读不到时退化为「%APPDATA%\Vocalkey\device.id」里的持久随机值。
// 发到后端前做一次哈希，避免把原始 GUID 暴露在请求里。

import { cppRegReadValue, cppGetEnvVar, cppReadStringFile, cppWriteStringFile } from '../api/cpp';

let cachedDeviceId = '';

/** 32 位 FNV-1a，输出 8 位十六进制 */
function hash32(str) {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return ('00000000' + h.toString(16)).slice(-8);
}

function readMachineGuid() {
    const keys = ['HKLM', 'HKEY_LOCAL_MACHINE'];
    const paths = [
        'SOFTWARE\\Microsoft\\Cryptography',
        'SOFTWARE\\WOW6432Node\\Microsoft\\Cryptography',
    ];
    for (let i = 0; i < keys.length; i++) {
        for (let j = 0; j < paths.length; j++) {
            let v = '';
            try {
                v = cppRegReadValue(keys[i], paths[j], 'MachineGuid');
            } catch (e) {
                v = '';
            }
            if (v && String(v).length >= 8) return String(v).trim();
        }
    }
    return '';
}

function readFallbackFile() {
    let dir = '';
    try {
        dir = cppGetEnvVar('APPDATA') || '';
    } catch (e) {
        dir = '';
    }
    if (!dir) return '';
    const file = dir + '\\Vocalkey\\device.id';
    let v = '';
    try {
        v = cppReadStringFile(file) || '';
    } catch (e) {
        v = '';
    }
    if (v && String(v).trim()) return String(v).trim();
    const seed = 'rnd-' + Date.now() + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    try {
        cppWriteStringFile(file, seed);
    } catch (e) {
        // 写不进去也无所谓，本次会话内用这个值
    }
    return seed;
}

/** 稳定的设备标识（16 位十六进制） */
export function getDeviceId() {
    if (cachedDeviceId) return cachedDeviceId;
    let raw = '';
    try {
        raw = readMachineGuid();
    } catch (e) {
        raw = '';
    }
    if (!raw) {
        try {
            raw = readFallbackFile();
        } catch (e) {
            raw = '';
        }
    }
    if (!raw) raw = 'unknown';
    cachedDeviceId = hash32(raw) + hash32('yyb-' + raw);
    return cachedDeviceId;
}
